module.exports = __webpack_public_path__ + "static/media/lake-g69ac8032a_640.298d14d9.jpg";